import { render } from "./ProduOrderInfo.vue?vue&type=template&id=9d55bdde&scoped=true"
import script from "./ProduOrderInfo.vue?vue&type=script&lang=js"
export * from "./ProduOrderInfo.vue?vue&type=script&lang=js"

import "./ProduOrderInfo.vue?vue&type=style&index=0&id=9d55bdde&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-9d55bdde"

export default script